// extracted by mini-css-extract-plugin
export var childrenContainer = "_bw-0";
export var virtualScrollArea = "_bw-1";